import { type FC, type MouseEvent } from "react";

import { CrossIcon } from "@snapchat/snap-design-system-icons";
import { useIntl } from "react-intl";

import { ModalClose, ModalCloseX } from "./ModalCloseButton.styles";
import { messages } from "./messages.generated";

interface ModalCloseButtonProps {
    onClick: (event: MouseEvent<HTMLElement>) => void;
}

export const ModalCloseButton: FC<ModalCloseButtonProps> = ({ onClick }) => {
    const intl = useIntl();

    return (
        <ModalClose onClick={onClick} type="button" aria-label={intl.formatMessage(messages.closeAriaText)}>
            <ModalCloseX>
                <CrossIcon />
            </ModalCloseX>
        </ModalClose>
    );
};
